export default "__VITE_ASSET__DWzUfula__"